var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentsData.type == 5)?_c('div',{style:(`padding: ${_vm.componentsData.content.marginData.top}px ${_vm.componentsData.content.marginData.left}px;background: ${_vm.bg_color};`)},[_c('div',{style:(`height: ${_vm.componentsData.content.height}px;`)},[_c('imageStyle',{staticClass:"h100",attrs:{"imageData":_vm.componentsData}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }